import {useState, useEffect} from 'react';
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import styles from './NaoEncontrada.module.css';
import LogoComTijolos from "../../assets/LogoComTijolos.png"; // Importe a imagem

export default function NaoEncontrada() {
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
    const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
      window.innerWidth < 768
    );
  
    function handleWindowSizeChange() {
      setIsSmallScreen(window.innerWidth < 768);
    }
  
    useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      // Executar uma vez no início para garantir que o estado é atualizado com a largura da janela atual
      handleWindowSizeChange();
  
      return () => window.removeEventListener('resize', handleWindowSizeChange);
    }, []);


  return (
    <div>
      <Header
          boxShadow
          mobileMenuActiveState={isMobileMenuVisible}
          toggleMobileMenu={setIsMobileMenuVisible}
          isSmallScreen={isSmallScreen}
          hamburgerIcon={false}
      />
      <main className={styles.main}>
        <img src={LogoComTijolos} alt="Logo com tijolos" /> 
        <h1>Desculpe, a página não pode ser localizada.</h1>
        <h2>Tente novamente ou volte para a página inicial.</h2>
      </main>
      {!isSmallScreen && <Footer />}
    </div>
  )
}
